import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "../../helpers/url_helper";

import { get, post, put, del } from "../../helpers/api_helper";


export const getBlog = createAsyncThunk(
    "getBlog",
    async ({ data, callback }, Thunk) => {
      try {
        //const queryParams = new URLSearchParams(data).toString();
        //const url = `${URL.GET_BLOG}?${queryParams}`;
        let response = await post(URL.GET_BLOG, data);
        callback && callback(null, response.data);
        return response;
      } catch (error) {
        callback && callback(error?.data?.message || error.message || error);
        return Thunk.rejectWithValue(error);
      }
    }
  );

  export const addBlog = createAsyncThunk(
    "addBlog",
    async ({ data, callback }, Thunk) => {
      try {
        let response = await post(URL.ADD_BLOG, data);
        callback && callback(null, response);
        return response;
      } catch (error) {
        callback && callback(error?.data?.message || error.message || error);
        return Thunk.rejectWithValue(error);
      }
    }
  );
  export const editBlog= createAsyncThunk(
    "editBlog",
    async ({ data, callback }, Thunk) => {
      try {
        let response = await put(URL.EDIT_BLOG + data?._id, data);
        callback && callback(null, response);
        return response;
      } catch (error) {
        callback && callback(error.message, null);
        return Thunk.rejectWithValue(error);
      }
    }
  );
  
  export const deleteBlog = createAsyncThunk(
    "deleteBlog",
    async ({ data, callback }, thunkAPI) => {
      console.log(data,"data++=++++++++++++++++++++")
      try {
        const response = await del(URL.DELETE_BLOG + data);
        console.log(data,"data----------->")
        callback && callback(null, response);
        return response;
      } catch (error) {
        toast.error(error?.message || "Something went wrong!")
  
        return thunkAPI.rejectWithValue(error);
      }
    }
  );